import request from '../../utils/request'

// 获取档案列表信息
export const getReportList = (data) => {
  return request({
    url: `/api/admin/wuyun-orders/list?pageNum=${data.pageNum}&pageSize=${data.pageSize}&keyword=${data.keyword}&orderType=${data.orderType}&orderStatus=${data.orderStatus}&reportStatus=${data.reportStatus}`,
    method: 'get'
  })
}

// 生成pdf文档
export const getReportPdf = (orderId) => {
  return request({
    url: `/api/admin/wuyun-orders/download/${orderId}`,
    method: 'get'
  })
}